<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('NEW_CALL.TITLE')"
        :header-content="$t('NEW_CALL.DESC')"
      />
      <CallForm
        :contact="contact"
        @onSubmit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
      <!-- <conversation-form
        :contact="contact"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      /> -->
    </div>
  </woot-modal>
</template>

<script>
import CallForm from './CallForm.vue';

export default {
  components: {
    CallForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    // eslint-disable-next-line consistent-return
    async onSubmit(inbox) {
        console.log("inbox = ",inbox);
        this.$emit("onSubmit",inbox)
    },
  },
};
</script>
